import { FormErrors } from 'redux-form';
import { MapView } from '@Selectors/tool/pairing/create/view/MapView';
import { VersionGame } from '@Models';

const validate = (values: CreateDraftParams): FormErrors<CreateDraftParams> => {
  const errors: FormErrors<CreateDraftParams> = {};

  if (!values.versionId || values.versionId <= 0) {
    errors.versionId = 'tool.pairing.form.version_id.error';
  }

  if (!values.size || values.size <= 0) {
    errors.size = 'tool.pairing.form.size.error';
  }

  if (!values.tables || values.tables.length < values.size) {
    errors.tables = 'tool.pairing.form.tables.error';
  }

  return errors;
};
export default validate;

export type CreateDraftParams = {
  versionId: number;
  game: VersionGame;
  size: number;
  tables: Array<MapView>;
};
